<template>
  <v-menu
    offset-y
    :nudge-bottom="10"
    transition="slide-y-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        slot="activator"
        v-on="on"
      >
        <v-icon>apps</v-icon>
      </v-btn>
    </template>

    <v-card class="my-essentials">
      <v-container fluid>
        <v-row>
          <v-col
            class="text-center"
            v-for="app in mappedData"
            :key="app.id"
            xs4
          >
            <div>
              <a>
                <svg :class="'icon ' + app.iconClass">
                  <use v-bind="{ 'xlink:href': app.xlinkHref }"></use>
                </svg>
                <span class="appTitle">{{app.title}}</span>
              </a>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-card-actions class="pa-0 card-actions">
      <v-btn>My essentials</v-btn>
    </v-card-actions>
  </v-menu>
</template>

<script>
  export default {
    name: "MyEssentials",
    props: {
      essentialsData: Array,
    },
    data() {
      return {
        iconToClass: window.iconToClass
      }
    },
    computed: {      
      mappedData() {
        return this.essentialsData.map((data) => {
          if (data.icon in this.iconToClass) {
            return {...data, 
              iconClass: this.iconToClass[data.icon],
              icon: data.icon.substring(3),
              xlinkHref: '#' + data.icon.substring(3)
            };
          }
          return data;
        });
      }
    }
  }
</script>

<style scoped>
  .my-essentials {
    width: 18.9375rem;
    padding-bottom: 50px;
  }

  .icon {
    width: 3.875rem;
    height: 3.875rem;
    border-radius: 7px;
  }

  .appTitle {
    display: block;
    color: #525252;
    line-height: 1.23;
    font-family: Arial;
    font-size: 13px;
  }

  .v-card__actions.card-actions .v-btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 0 !important;
    font-family: Arial;
    font-size: 13px;
    color: #525252;
    text-transform: capitalize;
  }
</style>